import ListBulletedIcon from '@atlaskit/icon/core/list-bulleted';
import * as React from 'react';

export function SvgList() {
  return <ListBulletedIcon label="" testId="ads-refreshed-icon" />;
}
